import { Grid } from "@mui/material";
import CustomText from "../components/CustomText";
import { Helmet } from "react-helmet-async";

const TermsOfUse = () => {
  return (
    <>
      <Helmet>
        <title>Términos de Uso | Centro Médico MEDAM</title>

        <meta
          name="description"
          content="Consulta los Términos de Uso del sitio web del Centro Médico MEDAM. Conoce las condiciones de acceso, propiedad intelectual, privacidad, responsabilidades y disposiciones legales aplicables."
        />

        <meta
          name="keywords"
          content="términos de uso, condiciones de uso, Centro Médico MEDAM, políticas del sitio web, aviso legal, propiedad intelectual, privacidad, Estado de México"
        />

        <meta
          property="og:title"
          content="Términos de Uso | Centro Médico MEDAM"
        />

        <meta
          property="og:description"
          content="Revisa las condiciones de uso del sitio web del Centro Médico MEDAM, incluyendo privacidad, responsabilidades, propiedad intelectual y marco legal."
        />

        <meta property="og:type" content="website" />

        <meta
          property="og:url"
          content="https://centromedicomedam.com/terminos-de-uso"
        />

        <meta
          property="og:image"
          content="https://centromedicomedam.com/IMG/centromedicoMEDAM/Logo_Centro_Medico_Medam_Color.png"
        />

        <meta property="og:site_name" content="Centro Médico MEDAM" />

        <meta property="og:locale" content="es_MX" />

        <meta name="twitter:card" content="summary_large_image" />

        <meta
          name="twitter:title"
          content="Términos de Uso | Centro Médico MEDAM"
        />

        <meta
          name="twitter:description"
          content="Consulta los términos y condiciones para el uso del sitio web oficial del Centro Médico MEDAM."
        />

        <meta
          name="twitter:image"
          content="https://centromedicomedam.com/IMG/centromedicoMEDAM/Logo_Centro_Medico_Medam_Color.png"
        />

        <meta name="robots" content="index, follow" />

        <link
          rel="canonical"
          href="https://centromedicomedam.com/terminos-de-uso"
        />
      </Helmet>

      <Grid container width="100%" sx={design.BackGroud}>
        <Grid size={design.Grid1} />
        <Grid container size={design.Grid10} pt={3}>
          <CustomText
            variant="subtitle1"
            color="#333333"
            text="Contacto para médicos"
            sx={design.Titulo}
          >
            Términos de uso
          </CustomText>
          <Grid container width="100%" pb={5}>
            <Grid size={design.Grid2} />
            <Grid size={design.Grid8}>
              <CustomText
                variant="subtitle1"
                color="#333333"
                text="Eres medico y quieres"
                sx={design.Description}
              >
                <strong>1. Aceptación de los términos:</strong> Al acceder y
                utilizar el sitio web del Centro Médico MEDAM (en adelante "el
                Sitio"), propiedad de HD Salud Integral S.A. de C.V., usted
                acepta estar sujeto a los presentes Términos de Uso. Si no está
                de acuerdo con estos términos, le recomendamos no utilizar el
                Sitio.
                <br />
                <br />
                <strong>2. Uso permitido:</strong> El Sitio está diseñado para
                brindar información general sobre los servicios médicos y de
                salud ofrecidos por el Centro Médico MEDAM. No sustituye
                asesoría médica profesional. El uso del Sitio con fines ilegales
                o no autorizados está prohibido.
                <br />
                <br />
                <strong>3. Propiedad intelectual:</strong> Todos los contenidos
                del Sitio, incluyendo textos, imágenes, logotipos y diseños,
                están protegidos por derechos de propiedad intelectual y son
                propiedad de HD Salud Integral S.A. de C.V. o sus licenciantes.
                Está prohibida su reproducción o uso no autorizado.
                <br />
                <br />
                <strong>4. Privacidad y datos personales:</strong> El
                tratamiento de los datos personales recopilados en el Sitio se
                rige por nuestro Aviso de Privacidad. Al usar el Sitio, usted
                consiente dicho tratamiento conforme a lo establecido.
                <br />
                <br />
                <strong>5. Modificaciones:</strong> HD Salud Integral S.A. de
                C.V. se reserva el derecho de modificar en cualquier momento
                estos Términos de Uso sin previo aviso. Las modificaciones
                entrarán en vigor desde su publicación en el Sitio.
                <br />
                <br />
                <strong>6. Responsabilidad:</strong> HD Salud Integral S.A. de
                C.V. no garantiza la disponibilidad continua del Sitio ni se
                responsabiliza por daños derivados del uso del mismo o de la
                información contenida en él.
                <br />
                <br />
                <strong>7. Jurisdicción:</strong> Estos Términos se rigen por
                las leyes del Estado de México. Cualquier controversia derivada
                de su aplicación se someterá a los tribunales competentes de
                dicha entidad federativa.
              </CustomText>
            </Grid>
            <Grid size={design.Grid2} />
          </Grid>
        </Grid>
        <Grid size={design.Grid1} />
      </Grid>
    </>
  );
};
export default TermsOfUse;
const design = {
  BackGroud: {
    backgroundImage: `url(https://centromedicomedam.com/IMG/centromedicoMEDAM/background_mini_logos_paquetes_del_centro-medico_MEDAM.png)`,
    backgroundPosition: "center",
    backgroundSize: "cover",
    backgroundRepeat: "no-repeat",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    alignContent: "center",
    flexDirection: "column",
  },
  Titulo: {
    fontFamily: "Plus Jakarta Sans",
    fontSize: {
      xs: 25,
      sm: 25,
      md: 40,
      lg: 40,
    },
    fontWeight: 700,
    lineHeight: "normal",
    textAlign: "center",
    paddingTop: 2,
    width: "100%",
  },
  Description: {
    fontFamily: "Plus Jakarta Sans",
    fontSize: {
      xs: 18,
      sm: 18,
      md: 20,
      lg: 20,
    },
    lineHeight: "normal",
    textAlign: "justify",
    width: "100%",
    marginTop: 2,
  },
  Grid1: { xs: 0.5, md: 1, xl: 1, lg: 1 },
  Grid2: { xs: 0.5, md: 3, xl: 3, lg: 3 },
  Grid8: { xs: 11, md: 6, xl: 6, lg: 6 },
  Grid10: { xs: 11, md: 10, xl: 10, lg: 10 },
};
